<template>
  <div>
    <div ref="container" class="component-container glasses" @click="showGlassOptions = !showGlassOptions">
      <div class="component__select" :class="{ open: showGlassOptions }">
        <span class="component__select--name">
          <h4>{{ label ? label : '' }}</h4>
          <span class="name"><img class="img-select" :src="getImg(value.img)" />{{ value ? value.name : '' }}</span>
          <RoundButton
            v-bind:class="showGlassOptions ? 'rotate' : 'normal'"
            class="bordered button"
            :width="currentScreenWidth > 1280 ? 40 : 30"
            image="ic-arrow-drop-down.svg"
          />
        </span>
      </div>
      <ul class="component__select-options" v-if="showGlassOptions">
        <li
          class="select--option"
          v-for="(option, index) in options"
          v-bind:key="option.id"
          @click="selectGlassOption(index)"
        >
          <label class="labelSelect">
            <input type="checkbox" :value="option" />
            <span class="name"><img class="img-select" :src="getImg(option.img)" />{{ option.name }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import RoundButton from '@Components/Menus/RoundButton.vue';
export default {
  name: 'ColorTintsSelect',
  components: {
    RoundButton,
  },
  watch: {
    $route() {
      this.product = null;
    },
  },
  props: ['options', 'value', 'label'],
  data: () => ({
    product: null,
    showGlassOptions: false,
    showTintsOptions: false,
  }),
  methods: {
    getImg(name) {
      return require('../../../../public/demo/photo/transitions/' + name);
    },
    selectGlassOption(index) {
      this.product = this.options[index];
      this.$emit('input', index);
    },
  },
  computed: {
    currentScreenWidth() {
      return window.outerWidth;
    },
  },
};
</script>

<style scoped>
.image-size {
  height: 40px;
}

.component__select--name {
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  transition: background-color 800ms;
}
.rotate {
  transform: rotateZ(180deg);
  transition: transform 300ms;
}
.normal {
  transform: rotateZ(0deg);
  transition: transform 300ms;
}

.no-touchevents .component__select--name:hover > .normal {
  border-color: black;
}

.no-touchevents .component__select:hover {
  /*
        background-color: rgba(255, 255, 255, 1);
      */
  transition: background-color 200ms;
}

.name {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 24px;
  color: black;
  letter-spacing: 0.5px;
}
.component__select-options .name {
  font-size: 18px;
}
.component__select-options {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 1%;
  cursor: pointer;
  background-color: white;
  margin: 0;
  position: absolute;
  bottom: 100%;
  text-align: center;
}
.labelSelect {
  position: relative;
  cursor: pointer;
}

.no-touchevents .select--option:hover .labelSelect::after {
  position: absolute;
  top: 100%;
  left: 0;
  content: '';
  width: 50%;
  padding-top: 4px;
  display: block;
  text-align: center;
  margin: auto;
  border-bottom: 2px solid #0088ec;
}
.select--option {
  margin-bottom: 10px;
  height: 35px;
  align-content: center;
  list-style: none;
}

.select--option:last-child {
  border-bottom: none;
}

.select--option:nth-child(2n) {
  background-color: #ffffff;
}

.select--option input {
  display: none;
}
.component__select--name > .name {
  margin-right: 5%;
}
.component__select--name > h4 {
  font-size: 25px;
  margin-right: 5%;
}

.component__select--name > img {
  margin-right: 5%;
}

.img-select {
  max-height: 40px;
}

h4 {
  white-space: nowrap;
}
@media only screen and (max-width: 1280px) {
  .image-size {
    height: 30px;
  }
  .component__select--name > img {
    width: 50%;
    margin-right: 0;
  }
  .component__select--name > h4 {
  }
}
</style>
